<template>
    <!--srccomponentsgui_mark_totalgui_mark_totalvuehtmlStart-->

    <div id="defaultId1" class="  u6dd13"       :style="{ backgroundImage: `url(${require('@/assets/' + MoudeImg)})`}">
        <div id="ge25b1" class="  u3da49">
            <div class="text_label">
                {{ label }}
            </div>
        </div>
        <el-tooltip :disabled="total.length < 50" :content="total | FilterNum" placement="top">
       
              <div id="g87d25" :class=" $route.query.Moudles=='Trade'?'u8dd69Trade':'u8dd69'  ">{{ total | FilterNum }}
           
          </div>
        </el-tooltip>
    </div>
    <!--srccomponentsgui_mark_totalgui_mark_totalvuehtmlEnd-->

</template>
<script>
// interfaceCode
//importStart

//importEnd

export default {
    name: '',
    props: {
        // srccomponentsgui_mark_totalgui_mark_totalvuePropsStart

        // 
        label: {
            type: String,
            default: ''
        },
        MoudeImg :{
          type: String,
            default: "images/jiugonggeBg.png"
        },
        // 
        total: {
            type: [String, Number],
            default: null
        }
        // srccomponentsgui_mark_totalgui_mark_totalvuePropsEnd


    },
    mounted() {
        // defaultLoad
        // srccomponentsgui_mark_totalgui_mark_totalvueMountedStart

        // srccomponentsgui_mark_totalgui_mark_totalvueMountedEnd


    },
    components: {

    },
    data() {
        return {
            // insertData
            // srccomponentsgui_mark_totalgui_mark_totalvueDataStart

            // srccomponentsgui_mark_totalgui_mark_totalvueDataEnd

        }
    },
    methods: {
        default() {

        },
        // insertMethod
        // srccomponentsgui_mark_totalgui_mark_totalvueMethodStart

        // srccomponentsgui_mark_totalgui_mark_totalvueMethodEnd

        // methodsCode

    },
    computed: {
        
    }
}
</script>
<style>
.srccomponentsgui_mark_totalgui_mark_totalvuecssStart {}

.u6dd13 {
    display: flex;
    justify-content: space-evenly;
    align-items: center;
    flex-direction: column;
    min-width: 8.57em;
    padding: 5px 10px;
    min-height: 70px;
    max-width: 18.857143rem;
    border-radius: 0.28em;
    /* border: 1px solid #A2A9B0; */
    /* tradejiugonge */
    /* background-image: url('../../assets/images/jiugonggeBg.png'); */
        background-size: 100% 100%;
        background-repeat:no-repeat;
    /* 背景图覆盖整个区域 */
    /* background-position: 50% 7.142857142857143rem; */
    pointer-events: auto;
    /* 允许与伪元素交互 */
}

.u3da49 {

    /* margin-bottom: 8px; */
    text-align: center;
    /* height: 50%;
    display: flex;
    align-items: center; */
}

.text_label {
    font-size: 1.285714rem;
  color: #1290C9;
        width: fit-content;
        font-family: 'DMSans Bold';
}
.u8dd69Trade{
    color: #1290C9;
    font-size: 1.285714rem;
    text-align: center;
}
.u8dd69 {
    font-size: 1.14285714rem;
    text-align: center;
        display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    overflow: hidden;
    text-overflow: ellipsis;
    /* line-height: 12px; */
}

@media screen and (max-width: 1441px) {

    .text_label,.u8dd69Trade,
    .u8dd69 {
        font-size: 16px;
    }

    .text_label {
        /* width: max-content; */
    }
    .u661e6{
        margin-left:5.5px !important;
        margin-right:5.5px !important;
        padding: 0.7571428rem !important;
    }
  
}

.srccomponentsgui_mark_totalgui_mark_totalvuecssEnd {}


/*cssStart*/

/*cssEnd*/
</style>